import React from 'react';

import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter';

export interface ControlledOptionsFilterProps {
  isCreatable?: boolean;
  isSearchable?: boolean;
  label?: string;
  name: string;
  onChange: (value: Option[]) => void;
  options: Option[];
  validateProp?: (value: string) => string | boolean;
  value: Option[];
}

function ControlledOptionsFilter({
  isCreatable = false,
  isSearchable = false,
  label = undefined,
  name,
  onChange,
  options,
  validateProp = undefined,
  value,
}: ControlledOptionsFilterProps): React.JSX.Element {
  const selectedValues = value.map((option) => option.value);

  const handleChange = (nextValues: string[]) => {
    onChange(nextValues.map((nextValue) => (
      options.find(({ value: optionValue }) => optionValue === nextValue) ?? {
        label: nextValue,
        value: nextValue,
      }
    )));
  };

  return (
    <OptionsFilter
      isCreatable={isCreatable}
      isSearchable={isSearchable}
      label={label}
      name={name}
      onChange={handleChange}
      options={options}
      validateProp={validateProp}
      value={selectedValues}
    />
  );
}

export { ControlledOptionsFilter };
